import React, { createContext, useContext, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { User } from '../states/actions';
import en from './en.json';
import et from './et.json';

const translations = { en, et };

const I18nContext = createContext({
	locale: 'en',
	t: (key) => key,
});

export const I18nProvider = ({ children }) => {
	const user = useSelector(User.get());
	const locale = user?.locale === 'et' ? 'et' : 'en';
	const dictionary = translations[locale] || translations.en;

	const t = useCallback(
		(key, vars = {}) => {
			let str = dictionary[key] ?? translations.en[key] ?? key;
			Object.entries(vars).forEach(([k, v]) => {
				str = str.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v);
			});
			return str;
		},
		[dictionary],
	);

	const value = useMemo(() => ({ locale, t }), [locale, t]);

	return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useTranslation = () => useContext(I18nContext);
